import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

const defaultSuffix = '([!%]?[\\w]*)'; // like !default / !edit / %21viewLogs

export const legacyReportsRecentlyCreatedRoute: InvariantRoute = {
	name: 'legacy-reports-recently-created-report',
	path: `/secure/ConfigureReport${defaultSuffix}.jspa`,
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:recentlycreated-report'],
};
